export default `package main

import (
	"crypto/hmac"
	"crypto/sha256"
	"encoding/hex"
	"fmt"
)

const APIKey = "YOUR_API_KEY"

func GenerateCannyHash(userID string) string {
	key := []byte(APIKey)
	h := hmac.New(sha256.New, key)
	h.Write([]byte(userID))
	return hex.EncodeToString(h.Sum(nil))
}

func main() {
	userID := "exampleUserID"
	hash := GenerateCannyHash(userID)
	fmt.Println("Generated Hash:", hash)
}
`;
